<template>
    <div>
        <div class="default-table" :class="{'sortable': isSortable}">
            <div class="default-table-header">
                <div class="table-header-cell asc" v-for="key of objectKeys">
                    {{ key }}
                </div>
            </div>
            <div class="default-table-body" v-for="column in data">
                <tr role="row" v-if="column.department" class="even department">
                    <td colspan="11">
                        {{ column.department }}
                    </td>
                </tr>
                <div class="default-table-row" v-for="row in column.rows">
                    <div class="table-body-cell" v-for="item in Object.values(row)">
                        <div> {{ item }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-table" v-for="column in data">
            <div class="mobile-department">
                <div class="title">
                    {{ objectKeys[0] }}
                </div>
                <div>
                    {{ column.department }}
                </div>

            </div>
            <div class="mobile-table-row" v-for="item in column.rows">
                <div class="rows">
                    <div class="mobile-table-row-content" v-for="(content, key) in item" :key="key">
                        <div>
                            {{ mobileKeys[key] }}
                        </div>
                        <div>
                            {{ content }}
                        </div>
                    </div>

                </div>

            </div>

        </div>
        <v-pagination v-model="currentPage"
                      v-if="pagination"
                      :page-count="totalPages"
                      :classes="bootstrapPaginationClasses"
                      :labels="paginationAnchorTexts"></v-pagination>
    </div>

</template>

<script>
import vPagination from 'vue-plain-pagination';
import {mapGetters} from "vuex";

export default {
    props: {
        data: {
            type: Array,
        },
        isSortable: {
            type: Boolean,
            default: false
        },
        pagination: {
            type: Boolean,
            default: false
        },
        tableId: {
            type: Number
        },
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 30,
            bootstrapPaginationClasses: {
                ul: 'pagination',
                li: 'page-item',
                liActive: 'active',
                liDisable: 'disabled',
                button: 'page-link'
            },
            paginationAnchorTexts: {
                first: null,
                prev: 'предыдущий',
                next: 'последний',
                last: null
            }
        }
    },
    components: {
        vPagination
    },
    computed: {
        ...mapGetters(["schedules"]),
        objectKeys() {
            let weekDay = this.schedules.filter(r => r.id === this.tableId)
            return [
                "Специалист",
                "Специальность",
                "Должность",
                "Кабинет",
                `${weekDay[0].week_days && weekDay[0].week_days.monday.slice(0, 2)} | ПН`,
                `${weekDay[0].week_days && weekDay[0].week_days.tuesday.slice(0, 2)} | ВТ`,
                `${weekDay[0].week_days && weekDay[0].week_days.wednesday.slice(0, 2)} | СР`,
                `${weekDay[0].week_days && weekDay[0].week_days.thursday.slice(0, 2)} | ЧТ`,
                `${weekDay[0].week_days && weekDay[0].week_days.friday.slice(0, 2)} | ПТ`,
                `${weekDay[0].week_days && weekDay[0].week_days.saturday.slice(0, 2)} | СБ`,
                `${weekDay[0].week_days && weekDay[0].week_days.sunday.slice(0, 2)} | ВС`,
            ];
        },
        mobileKeys() {
            return {
                doctor: 'Специалист',
                speciality: 'Специальность',
                position: 'Должность',
                cabinet: 'Кабинет',
                monday: 'Понедельник',
                tuesday: 'Вторник',
                wednesday: 'Среда',
                thursday: 'Четверг',
                friday: 'Пятница',
                saturday: 'Суббота',
                sunday: 'Воскресенье',
            }
        }
    },
    mounted() {
    }

}
</script>

<style>
.time-table.container {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
}
</style>

<style lang="scss" scoped>

.default-table {
    width: 100%;
    display: table;

    @media screen and (max-width: 1023px) {
        display: none;
    }
}

.default-table-header {
    display: table-header-group;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 102, 136);
    border-bottom: 1px solid #111;
}

.sortable {
    .table-header-cell {
        &::after {
            content: '';
            display: block;
            background-image: url('../assets/images/sort_both.png');
            width: 24px;
            height: 18px;
            position: absolute;
            right: 0;
            top: 12px;

        }
    }

    .table-header-cell.asc {

        &::after {
            background-image: url('../assets/images/sort_asc.png');
        }
    }

}

.table-header-cell {
    display: table-cell;
    padding: 10px;
    border-bottom: 1px solid black;
    cursor: pointer;
    font-size: 14px;
    font-weight: 900;
    text-align: center;
    position: sticky;
    top: 91px;
    background-color: #006688;
    text-transform: capitalize;
    min-width: 70px;
}

.default-table-body {
    display: table-row-group;
}

.default-table-row {
    display: table-row;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
}

.table-body-cell {
    display: table-cell;
    text-align: center;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
    padding: 5px;
    background: #FFFFFF;
    vertical-align: middle;

    &:first-child {
        border-left: 1px solid #ddd;
        /*text-align: center;*/
    }

    /*&:last-child {*/
    /*    text-align: right;*/
    /*}*/
}


.pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0;

    .page-item {
        user-select: none;
        overflow: visible;
        font-size: 15px !important;
        height: 35px !important;
        -webkit-border-radius: 0 !important;
        border-radius: 0 !important;
        color: #28282a !important;
        background: transparent !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid #000 !important;
        line-height: 31px !important;
        padding: 0 8px 1px !important;
    }
}

.page-link {
    user-select: none;
    overflow: visible;
    font-size: 15px !important;
    height: 35px !important;
    -webkit-border-radius: 0 !important;
    border-radius: 0 !important;
    color: #28282a !important;
    background: transparent !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: 1px solid #000 !important;
    line-height: 31px !important;
    padding: 0 8px 1px !important;
}

.mobile-table {
    display: none;
    border: 1px solid #ccc;
    @media screen and (max-width: 1023px) {
        display: block;
    }
}

.mobile-table-row {
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
}

.mobile-department {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    background-color: rgb(160, 32, 96);
    color: #FFFFFF;
    font-weight: 700;
    font-size: 13px;
    text-transform: capitalize;
}

.mobile-department {
    div:last-child {
        text-align: right;
    }
}

.mobile-table-row-header {
    padding: 10px;
    text-align: left;
    font-size: 13px;

}

.mobile-table-row-content {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    text-align: right;
    font-size: 13px;
    text-transform: capitalize;

    div {
        display: flex;
        align-items: center;
        @media screen and (max-width: 510px) {
            max-width: 150px;
        }
    }
}

.mobile-table-row-content:last-child {
    background-color: rgb(240, 240, 240);
}

.mobile-table-row-content:nth-child(-n+4) {
    font-weight: 700;
}
</style>

<style lang="scss" scoped>
.page-item {
    cursor: pointer;
    margin-left: 10px;
    overflow: visible;
    font-size: 15px;
    color: #28282a !important;
    border: 1px solid #000 !important;
    line-height: 31px !important;

    .page-link {
        text-decoration: underline;
        height: 35px;
        padding: 0 10px;
        font-size: 15px;
    }
}

.page-item.disabled, .page-item.active {
    border: 1px solid #c1c1c1 !important;
}

.page-item.active {
    .page-link {
        color: #c1c1c1 !important;
    }
}

.department {
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    text-align: left;
    background-color: rgb(160, 32, 96);

    td {
        padding: 4px;
    }
}
</style>